import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'

const MutationObserver = window.MutationObserver

export const KibanaFrame = React.memo(function KibanaPage () {
  const { path } = useParams()
  const location = useLocation()
  const { replace } = useHistory()
  const internalChange = useRef(false)
  const appPath = useMemo(() => path + location.search + location.hash, [path, location])
  const [iframeUrl, setIframeUrl] = useState(getIFrameUrl(appPath))
  const delayHandle = useRef(0)

  useEffect(() => {
    if (!internalChange.current) {
      setIframeUrl(getIFrameUrl(appPath))
    }
    internalChange.current = false
  }, [appPath])

  const handleLoad = useCallback(
    function (e) {
      const win = e.target.contentWindow

      new MutationObserver(function () {
        if (delayHandle.current) {
          clearTimeout(delayHandle.current)
        }
        delayHandle.current = setTimeout(() => {
          const newPath = getAppUrl(win.location)
          if (appPath !== newPath) {
            internalChange.current = true
            replace(`/kibana/${newPath}`)
          }
        }, 400)
      }).observe(win.document.querySelector('body'), {
        childList: true,
        subtree: true
      })
    },
    [appPath, replace]
  )
  return (
    <div className={'main main--kibana'}>
      <iframe src={iframeUrl} className={'kibana-iframe'} onLoad={handleLoad} onChange={handleLoad} />
    </div>
  )
})

function getIFrameUrl (path) {
  return `/elastic/app/${decodeURIComponent(path || 'apm')}`
}

function getAppUrl (location) {
  return `${location.pathname ? location.pathname.replace('/elastic/app/', '') : 'apm'}${location.search}${location.hash}`
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/kibana/kibanaFrame.js